import { isAdminOnlyDoc, isMissionNotesDoc } from '../../../../utils/docTags';

export const DOC_DRAG = 'application/x-fokus-doc-id';
export const FOLDER_DRAG = 'application/x-fokus-folder-id';
export const PREFS_KEY = 'fokus:docs-browse-prefs';

export const VIEWS = [
  { id: 'large', label: 'Large icons' },
  { id: 'small', label: 'Small icons' },
  { id: 'list', label: 'List' },
  { id: 'details', label: 'Details' },
];

export const SORTS = [
  { id: 'name', label: 'Name' },
  { id: 'date', label: 'Date modified' },
  { id: 'type', label: 'Type' },
  { id: 'count', label: 'Count' },
];

export const ICON_SIZE = { large: 40, small: 16, list: 16, details: 16 };

export const loadPrefs = () => {
  try {
    const v = JSON.parse(localStorage.getItem(PREFS_KEY));
    if (v && VIEWS.some((x) => x.id === v.view) && SORTS.some((x) => x.id === v.sort)) {
      return { view: v.view, sort: v.sort, dir: v.dir === 'desc' ? 'desc' : 'asc' };
    }
  } catch {
    /* ignore */
  }
  return { view: 'large', sort: 'name', dir: 'asc' };
};

export const savePrefs = (prefs) => {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    /* ignore */
  }
};

export const isAppIcon = (icon) =>
  icon && typeof icon === 'object' && (icon.type === 'fontawesome' || icon.type === 'custom');

export const formatDetailsDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const docTypeLabel = (doc) => {
  if (isMissionNotesDoc(doc)) return 'Mission notes';
  if (isAdminOnlyDoc(doc)) return 'Admin-only';
  return 'Document';
};

export const compareItems = (a, b, sort, dir) => {
  const flip = dir === 'desc' ? -1 : 1;
  if (sort === 'name') {
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }) * flip;
  }
  if (sort === 'date') {
    const av = a.date || '';
    const bv = b.date || '';
    if (av === bv) return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    return (av < bv ? -1 : 1) * flip;
  }
  if (sort === 'type') {
    const t = a.type.localeCompare(b.type, undefined, { sensitivity: 'base' });
    if (t) return t * flip;
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
  }
  if (sort === 'count') {
    const av = a.count ?? -1;
    const bv = b.count ?? -1;
    if (av === bv) return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    return (av - bv) * flip;
  }
  return 0;
};
